import Vue from 'vue';
import App from './App.vue';
import router from './router';
import "./assets/font/font.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import 'swiper/swiper-bundle.css';
import axios from 'axios'
import VueAxios from 'vue-axios'

const runtimeConfig = window.__APP_CONFIG__ || {};
axios.defaults.baseURL = runtimeConfig.apiBaseUrl || process.env.VUE_APP_API_BASE_URL || "/jinluo-api";
axios.interceptors.request.use(
    config => {
        // console.log("request", config);
        if (config.url !== "/login") {
            let authorizationHeader = localStorage.getItem("AuthorizationHeader")
            if (authorizationHeader) {
                config.headers.common.Authorization = authorizationHeader;
            }
        }
        return config;
    }
)
axios.interceptors.response.use(
    config => {
        // console.log("response", config.headers);
        localStorage.setItem("AuthorizationHeader", config.headers.authorization);
        return config;
    }, error => {
        if (error && error.response && error.response.status === 401) {
            localStorage.clear();
        }
        return Promise.reject(error);
    }
)

Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(VueAxios, axios)

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
